module.exports = __webpack_public_path__ + "static/ip-ikon10-70daf5e41e33c81ddfa21f397635a0c3.png";